import { Paper, Grid2 as Grid, TextField } from "@mui/material"
import React from "react"
import useDebugInformation from "../../../../../../../../../../hooks/useDebugInformation"
import { StateKeys } from "@services/storage/storeTemplate"
import { useAppSelector } from "@store/hooks"

type FreeTypeProps = {
    options: any
    props: any
    handleChange: (event: React.ChangeEvent<HTMLInputElement>, value: any) => void
    sx: any
}

const FreeType: React.FC<FreeTypeProps> = ({ options, props, handleChange, sx }) => {
    const value = useAppSelector<string>(state => state.state[`RequiredOption${options.id + 1}Answer` as StateKeys])
    useDebugInformation("FreeTypes", { options, props, handleChange })
    return (
        (<Paper sx={sx} elevation={4}>
            <Grid
                size={{
                    xs: 12,
                    sm: 12
                }}>
                <TextField {...props} fullWidth style={{ minWidth: "fit-content" }} id={"standard-basic" + options.question.toLowerCase()} name={options.question} label={options.question} value={value || ""} onChange={handleChange} />
            </Grid>
        </Paper>)
    );
}

export default React.memo(FreeType)